import React, { useState, useCallback } from 'react';
import { newAssessment } from '../../services/authService';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { encodeId } from '../../utills/idUtils';
import Self from '../../assets/images/self.png';
import Other from '../../assets/images/360.png';
const NewAssessment = () => {
    const [isSaving, setIsSaving] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const navigate = useNavigate();
    const { state } = useAuth();
    const { user } = state;
    const userId = user?.user_id || null;

    const handleSubmit = useCallback(async (type, source_user_id) => {
        if (!type || type.trim() === '') {
            alert('Please select an assessment type.');
            return;
        }
        setIsSaving(true);
        setIsSaved(false);

        try {
            //console.log("Creating new assessment with type:", type, "and userId:", source_user_id); // Debug log
            const id = await newAssessment(type, source_user_id);
            //console.log("New Assessment ID:", id); // Debug log

            if (id) {
                const encodedId = encodeId(id);
                //console.log("Encoded ID:", encodedId); // Debug log
                type === 'self'
                    ? navigate(`/self-asmt/${encodedId}`)
                    : navigate(`/conn-asmt/${encodedId}`);
                setIsSaved(true);
            }
        } catch (error) {
            console.error('Error creating assessment:', error.message);
            alert(error.message);
        } finally {
            setIsSaving(false);
        }
    }, [navigate]);

    const startAssessment = useCallback(async (type) => {
        if (!type) {
            alert('Please select an assessment type.');
            return;
        }

        //console.log("Starting assessment with type:", type);
        await handleSubmit(type, userId);
    }, [handleSubmit, userId]);

    return (
        <div className="text-center p-4 lg:px-16">
            <h1 className="text-3xl font-bold mb-1 text-gray-800">Create New Assessment</h1>

            <div className="flex flex-col justify-center space-y-8">
                {/* Title Section */}
                <h1 className="text-center text-3xl font-bold mb-8">Begin Your Executive Presence Journey</h1>

                {/* Images Section */}
                <div className="flex flex-col lg:flex-row justify-center items-center lg:space-x-6 space-y-6 lg:space-y-0">
                    <div className="flex justify-center lg:w-1/2 w-full">
                        <img
                            src={Self}
                            alt="Self Assessment"
                            className="rounded-lg shadow-lg w-[80%] lg:w-[70%] max-w-xs"
                        />
                    </div>
                    <div className="flex justify-center lg:w-1/2 w-full">
                        <img
                            src={Other}
                            alt="360 Degree Assessment"
                            className="rounded-lg shadow-lg w-[80%] lg:w-[70%] max-w-xs"
                        />
                    </div>
                </div>

                {/* Assessment Cards Section */}
                <div className="flex flex-col lg:flex-row justify-center space-y-6 lg:space-y-0 lg:space-x-6">

                    {/* Self Assessment Section */}
                    <div className="lg:w-1/2 bg-blue-500 text-white p-6 rounded-3xl shadow-lg w-full cursor-pointer border-2 hover:border-blue-600 flex flex-col justify-between">
                        <div>
                            <p className="font-bold text-2xl text-left mb-4">Self Assessment</p>
                            <p className="text-left mb-6">
                                Reflect on your Executive Presence by evaluating your own strengths and areas for improvement.
                                This assessment helps you build self-awareness, a key component of Executive Presence.
                            </p>
                            <ul className="list-none text-left mb-6 space-y-2">
                                <li>Gain personal insights into your communication, confidence, and professional presence</li>
                                <li>Self-paced and private: Ideal for personal reflection and growth</li>
                                <li>Instant personalized feedback based on your responses</li>
                            </ul>
                        </div>
                        <button
                            className="bg-blue-700 text-white py-3 px-6 rounded-full shadow-md transition duration-300 ease-in-out hover:bg-blue-800 hover:shadow-lg w-full mt-auto"
                            onClick={() => startAssessment('self')}
                        >
                            START SELF ASSESSMENT
                        </button>
                    </div>

                    {/* 360 Degree Assessment Section */}
                    <div className="lg:w-1/2 bg-blue-500 text-white p-6 rounded-3xl shadow-lg w-full cursor-pointer border-2 hover:border-blue-600 flex flex-col justify-between">
                        <div>
                            <p className="font-bold text-2xl text-left mb-4">360 Degree Assessment</p>
                            <p className="text-left mb-6">
                                The 360-Degree Assessment collects feedback from multiple sources—peers, managers, and direct reports—providing a complete picture of how you’re perceived by others.
                            </p>
                            <ul className="list-none text-left mb-6 space-y-2">
                                <li>Offers objective feedback from multiple perspectives</li>
                                <li>Identifies blind spots in your professional impact</li>
                                <li>Provides actionable insights on how others perceive you</li>
                            </ul>
                        </div>
                        <button
                            className="bg-blue-700 text-white py-3 px-6 rounded-full shadow-md transition duration-300 ease-in-out hover:bg-blue-800 hover:shadow-lg w-full mt-auto"
                            onClick={() => startAssessment('360')}
                        >
                            START 360 DEGREE ASSESSMENT
                        </button>
                    </div>
                </div>

                {/* Status Messages */}
                {isSaving && <p className="text-blue-500 text-center mt-4">Saving assessment...</p>}
                {isSaved && <p className="text-green-500 text-center mt-4">Assessment saved successfully!</p>}
            </div>

        </div>
    );
};

export default NewAssessment;
